import SideMenu from "./Components/SideMenu";
import TopBar from "./Components/TopBar";
import WarningBar from "./Components/WarningBar";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import WarningPopup from "./Components/WarningPopup";

const AuthenticatedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { sideMenuOpen } = useSelector((state) => state.UI);
  const { poppedup, message } = useSelector((state) => state.warning);

  return (
    <div className="App">
      <TopBar />
      <WarningBar />
      <Grid container>
        <Grid item>
          <SideMenu
            sideMenuOpen={sideMenuOpen}
            toggleSideMenu={() => dispatch({ type: "TOGGLE_SIDE_MENU" })}
          />
        </Grid>
        <Grid
          item
          sx={{
            marginLeft: sideMenuOpen ? "240px" : "64px",
            marginTop: "108px",
            backgroundColor: "#F8FAFB",
            width: "100%",
            height: "100%",
            overflow: "auto",
          }}
        >
          {children}
        </Grid>
      </Grid>
      <WarningPopup
        open={!poppedup && message ? true : false}
        message={message}
      />
    </div>
  );
};

export default AuthenticatedRoute;
